/* eslint-disable react-hooks/exhaustive-deps */
import IconEdit from "@mui/icons-material/Edit";
import IconView from "@mui/icons-material/RemoveRedEye";
import { Button } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchLangResources } from "../../app/slices/languageSlice";
import { capitalizeWord, hasAccess, translate } from "../../app/utils";
import AppDataTable from "../../components/appDataTable/appDataTable";
import EmptyDataContainer from "../../components/emptyDataContainer/emptyDataContainer";
import ErrorContainer from "../../components/errorContainer/errorContainer";
import LoadingContainer from "../../components/loadingContainer/loadingContainer";
import LanguageDialog from "./LanguageDialog";

const LangResourceList = () => {
  const {
    get: { list, status: statusList, error: errorList },
  } = useSelector(({ languages }) => languages);
  const dispatch = useDispatch();
  const [resourceList, setLangResourceList] = useState(null);
  const [selectedLangResource, setSelectedLangResource] = useState(null);
  const [open, setOpen] = useState(false);

  const columns = [
    {
      name: "key",
      label: "Key",
    },
    {
      name: "en",
      label: "English",
    },
    {
      name: "sw",
      label: "Swahili",
    },
    {
      name: "displayStatus",
      label: "Status",
    },
  ];

  useEffect(() => {
    loadResources();
  }, []);

  useEffect(() => {
    if (list) {
      let formatted = [];

      for (const key in list) {
        const element = list[key];
        formatted.push({
          key,
          en: element.en,
          sw: element.sw,
          displayStatus: capitalizeWord(element.status),
          status: element.status,
        });
      }
      setLangResourceList(formatted);
    }
  }, [list]);

  //* methods
  const loadResources = () => {
    dispatch(fetchLangResources());
  };

  return (
    <div className="app-padding">
      <div className="container-100 mb-20 "></div>
      <div className="flex-row">
        <Button
          color="primary"
          variant="contained"
          onClick={() => {
            setOpen(true);
          }}
        >
          {translate("addResource")}
        </Button>
      </div>

      {statusList === "loading" && (
        <LoadingContainer message="Loading Publications..." />
      )}

      {errorList !== null && (
        <ErrorContainer
          onReload={() => {
            loadResources();
          }}
          message={errorList?.message}
        />
      )}

      {list?.length === 0 && statusList === "idle" && (
        <EmptyDataContainer
          message={"No resources added"}
          hasBackground={false}
        />
      )}

      {resourceList && (
        <AppDataTable
          id="resources-list"
          action={[
            {
              action: hasAccess({ type: "name", resource: "MANAGE LANGUAGES" })
                ? "Update"
                : "View",
              onClick: (item) => {
                setSelectedLangResource(item);
                setOpen(true);
              },
            },
          ]}
          actionIcon={
            hasAccess({ type: "name", resource: "MANAGE LANGUAGES" }) ? (
              <IconEdit color="secondary" />
            ) : (
              <IconView color="secondary" />
            )
          }
          columns={columns}
          data={resourceList}
          emptyMessage="No resources found"
          rowsPerPageOptions={[10, 20, 50, 100]}
          downloadFileName="System language resources"
        />
      )}

      {open && (
        <LanguageDialog
          selectedLangResource={selectedLangResource}
          open={open}
          handleClose={() => {
            selectedLangResource && dispatch(fetchLangResources());
            setSelectedLangResource(null);
            setOpen(false);
          }}
        />
      )}
    </div>
  );
};

export default LangResourceList;
